import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { Image } from 'components/Image/Image';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import { useSeenModulePixel } from 'hook/helper.hook';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import './RecentTransactionsRedesign.scss';
import TransactionErrorViewRedesign from './TransactionErrorViewRedesign';
import TransactionViewRedesign from './TransactionViewRedesign';

export const RecentTransactionsRedesign = props => {
  const pixel = useSeenModulePixel({
    'Module Name':
      'Recent Transactions' + (props.isErrored ? ' - Error State' : ''),
    Vertical: BANKING_VERTICAL,
  });

  if (props.isErrored) {
    return (
      <SectionContainer
        datatestid="recentTransactionsRedesign"
        className="RecentTransactionsRedesign fontLato"
      >
        {pixel}
        <Row>
          <Label
            datatestid="recentTransactionsRedesign-label"
            type="H3"
            typeHeader={'h3'}
            className="margB16"
          >
            Recent Transactions
          </Label>
        </Row>
        <Row>
          <TransactionErrorViewRedesign
            description="There was an error loading transactions."
            onRefreshClick={props.onRefreshClick}
          />
        </Row>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer
      datatestid="recentTransactionsRedesign"
      className="RecentTransactionsRedesign fontLato"
    >
      {pixel}
      <Row>
        <Label
          datatestid="recentTransactionsRedesign-label"
          type="H3"
          typeHeader={'h3'}
          className="margB16"
        >
          Recent transactions
        </Label>
      </Row>
      <Row>
        <FlexContainer
          column
          justifyCenter
          alignItemsStretch
          className="borderRadius8 grayShadow16"
        >
          <FlexContainer column>
            <TransactionViewRedesign
              limit={3}
              doNotIncludeBankTransfers={true}
              {...props}
              transactions={props.transactionsRecent}
            />
          </FlexContainer>
          <FlexContainer className="borderTpGray025 padTB10 m-padTB0">
            <Button
              datatestid="cash-tx-see-all"
              onClick={props.onSeeAllTransactionClick}
              mrphType="link"
              fullWidth
              className="flex-container justify-between items-align-center text-12 m-text-10"
            >
              VIEW ALL TRANSACTIONS <Image imgClass="chevronRight" />
            </Button>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
